<div class="flex flex-column" [formGroup]="fg">

  <!--productName-->
  <div class="flex flex-column pb-4">
    <label class="text-sm text-color-secondary"  for="productName">Nom du produit</label>
    <input pInputText formControlName="productName" id="productName" type="text" placeholder="Nom du produit">

    <!--Message d'erreur-->
    <div class="min-h-0">
      <p-message  class="p-message" severity="error" text="Le nom du produit est obligatoire"
      *ngIf="fg.get('productName')?.touched && fg.get('productName')?.errors?.['required']">
      </p-message>
    </div>
  </div>

  <!--productPurchasePrice-->
  <div class="text-sm text-color-secondary" class="flex flex-column pb-4">
    <label class="text-sm text-color-secondary" for="productPurchasePrice"> Prix d'achat</label>
    <input pInputText formControlName="productPurchasePrice" id="productPurchasePrice" type="number" placeholder="Prix d'achat">

    <!--Message d'erreur-->
    <div class="min-h-0">
      <ng-container *ngIf="fg.get('productPurchasePrice')?.invalid && (fg.get('productPurchasePrice')?.dirty || fg.get('productPurchasePrice')?.touched)">

        <!-- Info manquante-->
        <p-message *ngIf="fg.get('productPurchasePrice')?.hasError('required')"
          class="p-message" severity="error" text="Le prix d'achat est obligatoire">
        </p-message>

        <!-- Format erroné -->
        <p-message *ngIf="fg.get('productPurchasePrice')?.hasError('validateNumber')"
          class="p-message" severity="error" text="Le prix d'achat à un format invalide">
        </p-message>
      </ng-container>
    </div>
  </div>

  <!--productCategory-->
  <div class="flex flex-column pb-4">
    <label class="text-sm text-color-secondary" for="productCategory">Catégorie du produit</label>
    <p-select
    [options]="productCategories"
    formControlName="productCategory"
    optionLabel="name"
    placeholder="Catégoryie de produit" />

    <!--Message d'erreur-->
    <div class="min-h-0">
      <p-message  class="p-message" severity="error" text="La catégory de produit est obligatoire"
      *ngIf="fg.get('productCategory')?.touched && fg.get('productCategory')?.errors?.['required']">
      </p-message>
    </div>
  </div>

  <!--Photo a prendre avec un mobile-->
  <app-take-photo-on-mobile [fg]="fg" (selectedFileEmitter)="selectImageEmit($event)" inputFileFormControlName="selectedImage"></app-take-photo-on-mobile>


</div>
